<template>
  
  <div class="ui segment">

    <div :id="_uid" class="ui fluid accordion">  

      <h4 :id="_uid + '_title'" class="ui dividing header title">
        <i class="dropdown icon"></i>Filtros
      </h4>

      <div class="content active">
        <div class="ui form">
          <div class="fields">
            <div class="three wide field">
              <label class="form-label">Data Inicial <span class="red text">*</span></label>
              <date-picker ref="startDatePicker" @onChange="onChangeStartDate" />
            </div>
            <div class="three wide field">
              <label class="form-label">Data Final <span class="red text">*</span></label>
              <date-picker ref="endDatePicker" @onChange="onChangeEndDate" />
            </div>
            <div v-if="$isAdmin()" class="five wide field">
              <label class="form-label">Colaborador <span class="red text">*</span></label>
              <user-picker ref="userPicker" :onlySimavet="true" @onPick="onPickUser" @onClear="filter.user = null" />
            </div>
            <div class="five wide field">
              <label class="form-label">Status</label>
              <select-dropdown ref="statusDropdown" @onChange="onChangeStatus" />
            </div>            
          </div>          
        </div>  
        <button class="ui blue button m-t-10" :class="{ disabled: !filter.startDate || !filter.endDate || !filter.user }" @click="onApply()">
          <i class="check icon"></i> Aplicar
        </button>
      </div>

    </div>

  </div>

</template>

<script>

  import moment from "@/utils/moment"
  import EmployeeInvoiceService from "@/services/employee-invoice-service"
  import { DatePicker, SelectDropdown, UserPicker } from "@/components"

  export default {
    
    name: "EmployeeCertsFilter",

    data() {
      return {
        filter: { user: null },
      }
    },

    components: {
      DatePicker,
      SelectDropdown,
      UserPicker,
    },    

    mounted() {

      let hasFilter = false

      $(`#${this._uid}`).accordion()

      if (this.$store.state.pages.filters.financialEmployeeCerts) {
        hasFilter = true
        this.filter = this.$cloneObject(this.$store.state.pages.filters.financialEmployeeCerts)                      
      }        

      if (this.filter.startDate && this.filter.endDate) {
        this.$refs.startDatePicker.setDate(this.filter.startDate)
        this.$refs.endDatePicker.setDate(this.filter.endDate)
      }  

      this.$refs.statusDropdown.setValues(EmployeeInvoiceService.getFilterStatusList(), this.filter.status)

      if (!this.$isAdmin())
        this.filter.user = this.$store.state.auth.user

      if (this.filter.user && this.$refs.userPicker)
        this.$refs.userPicker.setSelected(this.filter.user)

      if (hasFilter) {
        $(`#${this._uid}_title`).click()
        this.onApply()
      }  
    },

    methods: {

      onChangeStartDate(date) {    
        this.$set(this.filter, "startDate", moment(date).format("YYYY-MM-DD"))
      },

      onChangeEndDate(date) {    
        this.$set(this.filter, "endDate", moment(date).format("YYYY-MM-DD"))
      },

      onChangeStatus(id) {
        this.$set(this.filter, "status", id)
      },

      onPickUser(user) {
        this.$set(this.filter, "user", user)
      },

      onApply() {

        this.updateStore()

        $(`#${this._uid}_title`).click()

        this.$emit("onApply", this.$cloneObject(this.filter))
      },

      updateStore() {

        let filters = this.$cloneObject(this.$store.state.pages.filters)

        filters.financialEmployeeCerts = this.$cloneObject(this.filter)

        this.$store.commit("pages/setFilters", filters)
      },
    },
  }

</script>